<template>
  <section class="hero is-fullheight" id="home">
    <div class="hero-head has-text-centered">
      <h1 class="is-size-1">Easy print your image</h1>
    </div>
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns">
          <div class="column is-12-mobile is-6-tablet">
            <img alt="preview" width="480px" :src="imgSrc" :style="style" />
          </div>
          <div class="column is-12-mobile is-6-tablet">
            <div class="columns is-mobile is-multiline">
              <div class="column is-12">
                <h3 class="is-size-3">Upload your image</h3>
                <b-field>
                  <b-upload
                    v-model="dropFiles"
                    accept="image/*"
                    @input="changed"
                    drag-drop
                  >
                    <section class="section">
                      <div class="content has-text-centered">
                        <p>
                          <b-icon icon="upload" size="is-medium"></b-icon>
                        </p>
                        <p>Drop your files here or click to upload</p>
                      </div>
                    </section>
                  </b-upload>
                </b-field>
              </div>
              <div class="column is-12">
                <h3 class="is-size-3">Select frame style</h3>
              </div>
              <div
                v-for="(frame, i) in frames"
                :key="i"
                class="column is-6-mobile is-4-tablet"
              >
                <a @click="changeFrame(i)">
                  <img :src="frame" width="100%" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      dropFiles: {},
      imgSrc: "https://picsum.photos/300/200",
      style: {
        border: "30px solid",
        borderImage: ""
      },
      frames: [
        require("../assets/frame1.png"),
        require("../assets/frame2.png"),
        require("../assets/frame3.png")
      ]
    };
  },
  created() {
    this.changeFrame(0);
  },
  methods: {
    changed() {
      this.imgSrc = window.URL.createObjectURL(this.dropFiles);
    },
    changeFrame(i) {
      this.style.borderImage = 'url("' + this.frames[i] + '") 50 round';
    }
  }
};
</script>
